import axios from 'axios';

const API_BASE_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

class SleepVideoV3Service {
  async list(params = {}) {
    const searchParams = new URLSearchParams();
    if (params.page != null) searchParams.set('page', String(params.page));
    if (params.pageSize != null) searchParams.set('pageSize', String(params.pageSize));
    if (params.channelId) searchParams.set('channelId', params.channelId);
    if (params.search) searchParams.set('search', params.search);
    const qs = searchParams.toString();
    const response = await axios.get(`${API_BASE_URL}/sleep-videos${qs ? `?${qs}` : ''}`);
    return response.data;
  }

  async listRenderStatuses() {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/render-statuses`);
    return response.data;
  }

  async listScriptStatuses() {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/script-statuses`);
    return response.data;
  }

  async listVoiceOverStatuses() {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/voiceover-statuses`);
    return response.data;
  }

  async get(id) {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/${id}`);
    return response.data;
  }

  async create({
    title,
    videoTitle,
    videoContext,
    channelId,
    voiceOverConfigId,
    qrCodeId,
    thumbnail,
  }) {
    const payload = { title: title?.trim() || '' };
    if (thumbnail !== undefined) payload.thumbnail = thumbnail;
    if (videoTitle != null) payload.videoTitle = videoTitle;
    if (videoContext != null) payload.videoContext = videoContext;
    if (channelId) payload.channelId = channelId;
    if (voiceOverConfigId) payload.voiceOverConfigId = voiceOverConfigId;
    if (qrCodeId) payload.qrCodeId = qrCodeId;
    const response = await axios.post(`${API_BASE_URL}/sleep-videos`, payload);
    return response.data;
  }

  async listQrCodes() {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/qr-codes`);
    return response.data;
  }

  async requestQrCodePresignedUrl({ fileName, fileSize, contentType }) {
    const response = await axios.post(
      `${API_BASE_URL}/sleep-videos/qr-codes/presigned-url`,
      { fileName, fileSize, contentType: contentType || 'image/png' },
    );
    return response.data;
  }

  async createQrCode(data) {
    const response = await axios.post(`${API_BASE_URL}/sleep-videos/qr-codes`, data);
    return response.data;
  }

  async updateQrCode(id, data) {
    const response = await axios.put(`${API_BASE_URL}/sleep-videos/qr-codes/${id}`, data);
    return response.data;
  }

  async deleteQrCode(id) {
    const response = await axios.delete(`${API_BASE_URL}/sleep-videos/qr-codes/${id}`);
    return response.data;
  }

  async generateVoiceOver(id, body = {}) {
    const response = await axios.post(
      `${API_BASE_URL}/sleep-videos/${id}/generate-voice-over`,
      body,
    );
    return response.data;
  }

  async update(id, data) {
    const payload = {};
    if (data.thumbnail !== undefined) payload.thumbnail = data.thumbnail;
    if (data.title !== undefined) payload.title = data.title;
    if (data.videoTitle !== undefined) payload.videoTitle = data.videoTitle;
    if (data.videoContext !== undefined) payload.videoContext = data.videoContext;
    if (data.channelId !== undefined) payload.channelId = data.channelId;
    if (data.useBackgroundMusic !== undefined) payload.useBackgroundMusic = data.useBackgroundMusic;
    if (data.used !== undefined) payload.used = data.used;
    if (data.fullScript !== undefined) payload.fullScript = data.fullScript;
    if (data.qrCodeId !== undefined) payload.qrCodeId = data.qrCodeId;
    const response = await axios.put(`${API_BASE_URL}/sleep-videos/${id}`, payload);
    return response.data;
  }

  async delete(id) {
    const response = await axios.delete(`${API_BASE_URL}/sleep-videos/${id}`);
    return response.data;
  }

  async getScriptStatus(id) {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/${id}/script-status`);
    return response.data;
  }

  async generate(id, body = {}) {
    const payload = {};
    if (body.videoTitle != null) payload.videoTitle = body.videoTitle;
    if (body.videoContext != null) payload.videoContext = body.videoContext;
    if (body.generationStep != null) payload.generationStep = body.generationStep;
    if (body.voiceOverConfigId != null) payload.voiceOverConfigId = body.voiceOverConfigId;
    const response = await axios.post(`${API_BASE_URL}/sleep-videos/${id}/generate`, payload);
    return response.data;
  }

  async requestVoiceoverPresignedUrl(id, { fileName, fileSize, contentType }) {
    const response = await axios.post(
      `${API_BASE_URL}/sleep-videos/${id}/voiceover-presigned-url`,
      { fileName, fileSize, contentType: contentType || 'audio/mpeg' },
    );
    return response.data;
  }

  async completeVoiceoverUpload(id, { objectName, fileSize, duration }) {
    const response = await axios.post(
      `${API_BASE_URL}/sleep-videos/${id}/voiceover-complete`,
      { objectName, fileSize, duration },
    );
    return response.data;
  }

  async render(id) {
    const response = await axios.post(`${API_BASE_URL}/sleep-videos/${id}/render`);
    return response.data;
  }

  async getPromptSystem() {
    const response = await axios.get(`${API_BASE_URL}/sleep-videos/prompt-system`);
    return response.data;
  }

  async updatePromptSystem(data) {
    const response = await axios.put(`${API_BASE_URL}/sleep-videos/prompt-system`, data);
    return response.data;
  }
}

export default new SleepVideoV3Service();
